import { WarningIcon } from '@assets/icons';
import { Flex, Text } from '@chakra-ui/react';

export default function WarningTagComp({ label = 'Label', ...props }) {
    return (
        <Flex gap={'8px'} alignItems={'center'} {...props}>
            <WarningIcon />
            <Text fontWeight={400} fontSize={'14px'} color={'warning.700'}>
                {label}
            </Text>
        </Flex>
    );
}
